export default function ($http) {
    return function (vehicleId, model) {
        return $http.post(`api/vehicles/${ vehicleId }/keepers`, model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/createKeeper.js